import { activationStore } from '@/stores/activation.store'
import { authStore } from '@/stores/auth.store'

export type OnboardingStop = 'cv' | 'jobSought' | 'discovery' | 'focus'

export const CANDIDATE_HOME = '/app/candidate/profile-hub'

const ROUTES: Record<OnboardingStop, string> = {
  cv: '/app/candidate/activate',
  jobSought: '/app/candidate/job-sought',
  discovery: '/app/candidate/discovery',
  focus: '/app/candidate/focus',
}

export function nextOnboardingStop(): OnboardingStop | null {
  if (authStore.state.userType !== 'candidate' || !activationStore.isLoaded()) {
    return null
  }
  if (activationStore.isLocked()) {
    return 'cv'
  }
  if (activationStore.needsJobSoughtForm() || authStore.candidateNeedsName) {
    return 'jobSought'
  }
  if (activationStore.needsDiscovery()) {
    return 'discovery'
  }
  if (activationStore.needsFocus()) {
    return 'focus'
  }
  return null
}

export function nextOnboardingRoute(): string {
  const stop = nextOnboardingStop()
  return stop === null ? CANDIDATE_HOME : ROUTES[stop]
}

export function routeForStop(stop: OnboardingStop): string {
  return ROUTES[stop]
}
